import React from "react";
import BaseChart from "./BaseChart";
import APILXD from "../../../../http/APILXD";
import {message} from "antd";
import HttpTool from "../../../../tool/HttpTool";

export default class ChartForCountryMsg extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      chartConfig: {}
    }
  }

  getData(pageParams){
    HttpTool.post(APILXD.getDeviceTop20, (code, msg, json) => {
      this.renderChart(json)
    }, (code, msg) => {
      message.error(msg);
    }, pageParams)
  }

  renderChart(data) {
    let newConfig = _.cloneDeep(this.state.chartConfig);

    let seriesData = [];
    data.sort((a,b)=>{return a.total-b.total}).forEach(d => {
      seriesData.push({
        name: d._id,
        value: d.total,
      })
    })

    newConfig.legend = {
      show: false,
    }
    newConfig.xAxis = {
      type: 'value',
    }
    newConfig.yAxis = {
      type: 'category',
    }
    newConfig.dataset = {
      dimensions: ["countryName", "total"],
      source: data,
    }
    newConfig.series = [
      {
        type: "bar",
        name: "个数",
      },
    ];

    this.setState({chartConfig: newConfig});
  }

  render() {
    return <BaseChart
      chartType={"bar"}
      chartConfig={this.state.chartConfig}
    />
  }
}